import { InjectionToken } from '@angular/core';

/**
 * Multi-provider injection token for registering API base URLs that should receive
 * the access token and client ID headers from the auth interceptors.
 *
 * Each provider contributes one URL string. The `OAuthModuleConfigProvider` consolidator
 * reads all registered URLs and merges them into `resourceServer.allowedUrls`.
 *
 * @example
 * // In a feature's provider function:
 * { provide: AUTHENTICATED_API_URL, useValue: 'https://my-api.example.com', multi: true }
 */
export const AUTHENTICATED_API_URL = new InjectionToken<string>('AUTHENTICATED_API_URL');
